module.exports = __webpack_public_path__ + "images/10c4b4f313cc068c2d8200d2182d41f0.jpg";